import { render, staticRenderFns } from "./WarehouseLayout.vue?vue&type=template&id=fa7c41f0&scoped=true"
import script from "./WarehouseLayout.vue?vue&type=script&lang=js"
export * from "./WarehouseLayout.vue?vue&type=script&lang=js"
import style0 from "./WarehouseLayout.vue?vue&type=style&index=0&id=fa7c41f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7c41f0",
  null
  
)

export default component.exports